module.exports = __webpack_public_path__ + "img/excess-inventory.2ce27d0f.svg";